module.exports = __webpack_public_path__ + "static/media/B3.3bf3d511.jpg";